module.exports = __webpack_public_path__ + "static/media/Tsavo_Bart_Nieuw.b006fb0c.png";